import { filter, map } from 'rxjs/operators';
import { pipe, Observable } from 'rxjs';
import { Command } from '../models/command.model';
import { OperationWithCommand } from '../models/operation-with-command.model';
import { Operation } from '../models/operation.model';

export const filterCommands = <TC extends Command, TO extends OperationWithCommand>(commandType: new() => TC) => {
    const operator = pipe<Observable<TO>, Observable<TO>>(
        filter(event => event.currentCommand instanceof commandType),
    );

    return operator;
};

export const castToCommand = <T extends Command>() => {
  const operator = pipe(
      map((operation: Operation) => operation.currentCommand as T),
  );

  return operator;
};
